export const isIE11 = !window.ActiveXObject && 'ActiveXObject' in window;
